import React from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";

const OPTIONS = ["floor", "inbound", "pallet", "rack", "trailer", "vault"];

export default function LocationTypeFilter({ selected = [], setSelected }) {
  const selectedValue = selected.length > 0 ? selected[0] : "";

  const handleSelect = value => {
    if (selectedValue === value) {
      setSelected([]);
    } else {
      setSelected([value]);
    }
  };

  return (
    <Box>
      {OPTIONS.map(option => (
        <MenuItem key={option} sx={{ fontSize: 14 }} onClick={() => handleSelect(option)}>
          <Box my={-1} ml={-1}>
            <Checkbox checked={selectedValue === option} value="" />
          </Box>
          <Box sx={{ textTransform: 'capitalize' }}>
            {option}
          </Box>
        </MenuItem>
      ))}
    </Box>
  );
}
